import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import formStyles, { gridStyle, Row } from 'utils/formStyles';

const useStyles = makeStyles((theme) => ({
  ...formStyles,
  wrapper: {
    width: 550,
    maxWidth: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  item: gridStyle(200, 320),
  search: gridStyle(200, '100%'),
}));

function QuickSearch(props) {
  const classes = useStyles();
  const { search, loaded } = props;
  const [text, setText] = useState('');
  const formValid = text.length >= 3;

  const onChange = (ev) => {
    const val = ev.target.value;
    setText(val);
  };

  const onKeyDown = (ev) => {
    if (ev.code === 'Enter') onSearch();
  };

  const onSearch = () => {
    if (formValid) search(text);
  };

  const renderSearch = () => {
    return (
      <TextField
        label="Search"
        type="search"
        className={classes.search}
        variant="outlined"
        size="small"
        onChange={onChange}
        value={text}
        onKeyDown={onKeyDown}
      />
    );
  };

  const renderSendBtn = () => {
    const disabled = !formValid || !loaded || !text || text.length < 3;
    return (
      <div className={classes.btn}>
        <Button onClick={onSearch} variant="outlined" disabled={disabled}>
          Search
        </Button>
      </div>
    );
  };

  return (
    <div className={classes.wrapper} style={props.style}>
      <Row>
        {renderSearch()}
        {renderSendBtn()}
      </Row>
    </div>
  );
}

export default QuickSearch;
